import React, { useState, useContext } from "react";
import styled from "styled-components";
import { Redirect } from "react-router-dom";

import TextField from "@material-ui/core/TextField";

import FirebaseContext from "../firebase/context";
import DashboardContext from "../context/DashboardContext";
import Button from "../components/Button";
import * as Typography from "../components/Typography";

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");

  const firebase = useContext(FirebaseContext);
  const { setIsAuthenticated, isAuthenticated, setUserEmail } = useContext(
    DashboardContext
  );

  const handleLogin = async () => {
    try {
      await firebase.signInWithEmailAndPassword(user, password);

      setIsAuthenticated && setIsAuthenticated(true);
      setUserEmail && setUserEmail(user);

      sessionStorage.setItem("email", user);
      sessionStorage.setItem("auth", "true");
    } catch {}
  };

  if (isAuthenticated) return <Redirect to="/dashboard" />;

  return (
    <div style={{ backgroundColor: "#f4f4f7", height: "100%" }}>
      <Container>
        <Card>
          <Typography.p weight={600}>Governança Corporativa</Typography.p>
          <TextField
            label="Email"
            value={user}
            onChange={(e) => setUser(e.target.value)}
          />
          <TextField
            label="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Separator />
          <Separator />
          <ButtonContainer>
            <Button
              variant="contained"
              color="primary"
              disabled={!password || !user}
              onClick={() => handleLogin()}
            >
              Login
            </Button>
          </ButtonContainer>
        </Card>
      </Container>
    </div>
  );
};

const Container = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffff;
  padding: 40px 60px;
  border-radius: 10 px;
  box-shadow: #00000040 0px 1px 4px 0px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Separator = styled.div`
  margin: 10px 0;
`;

export default Login;
